module.exports = __webpack_public_path__ + "static/img/fish34.c83f83a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish34.png
// module id = NLFK
// module chunks = 0